{
  "CodeDeliveryFailureException": "Unable to deliver code. Please try again later.",
  "CodeMismatchException": "The code you entered is invalid; please double-check and try again.",
  "ExpiredCodeException": "This code is expired.",
  "InvalidParemeterException": "Something went wrong. Please try again later.",
  "LimitExceededException": "Too many attempts. Please try again later",
  "NotAuthorizedException": "Your email and/or password are incorrect.",
  "UserNotConfirmedException": "Account is not confirmed.",
  "UserNotFoundException": "Your email and/or password are incorrect.",
  "UsernameExistsException": "Account already exists.",
  "accountNotConfirmed": "Account Not Confirmed",
  "anUnknownErrorOccurred": "An unknown error occurred",
  "codeSentToast": "Code sent.",
  "codeStringFieldLabel": "Code",
  "codeStringFieldPlaceholder": "Enter code",
  "confirmAccount": "Confirm Account",
  "confirmAccountButton": "Confirm Account",
  "confirmPasswordFieldLabel": "Confirm Password",
  "confirmPasswordFieldPlaceholder": "*******",
  "contactUs": "Contact Us",
  "createAnAccount": "Create an Account",
  "createUserAccount": "Create User Account",
  "credentialsSuccess": "You can now sign in with your new credentials.",
  "currentPasswordFieldLabel": "Password",
  "currentPasswordFieldPlaceholder": "*******",
  "emailFieldLabel": "Email",
  "emailFieldPlaceholder": "*******@example.com",
  "enterCodeFromYourEmail": "Enter the confirmation code we sent to your email address.",
  "enterYourEmail": "Enter your email address",
  "needToConfirmYourAccount": "Need to confirm your account?",
  "newPasswordFieldLabel": "Password",
  "newPasswordFieldPlaceholder": "Enter Password",
  "passwordResetCodeSentWithEmail": "We sent a one-time password reset code to {{email}} (Make sure to check your spam filter)",
  "passwordResetLinkTo": "Forgot your password?",
  "passwordResetTitle": "Password Reset",
  "signIn": "Sign In",
  "signOut": "Sign Out",
  "youMustConfirmYourAccount": "You must confirm your account before you can sign in."
}
